__turbopack_context__.v({
  "side-editor": "SideEditor-module-scss-module__A_vBma__side-editor",
  "side-editor-help-items": "SideEditor-module-scss-module__A_vBma__side-editor-help-items",
  "side-editor-menu": "SideEditor-module-scss-module__A_vBma__side-editor-menu",
  "side-editor-menu-item": "SideEditor-module-scss-module__A_vBma__side-editor-menu-item",
  "side-editor-menu-item-icon-container": "SideEditor-module-scss-module__A_vBma__side-editor-menu-item-icon-container",
  "side-editor-menu-item-title": "SideEditor-module-scss-module__A_vBma__side-editor-menu-item-title",
  "side-editor-menu-selected-indicator": "SideEditor-module-scss-module__A_vBma__side-editor-menu-selected-indicator",
  "side-editor-menu-wrapper": "SideEditor-module-scss-module__A_vBma__side-editor-menu-wrapper",
  "side-editor-panel": "SideEditor-module-scss-module__A_vBma__side-editor-panel",
  "side-editor-panel-wrapper": "SideEditor-module-scss-module__A_vBma__side-editor-panel-wrapper",
  "side-editor-panels": "SideEditor-module-scss-module__A_vBma__side-editor-panels",
});
